<div class="fd-tab-sections FT-portfolio block-border" id="portfolio" *ngIf="!disableTab">
  <div class="block-head">
    <h3 *ngIf="asOfDate !=='' || data?.asOfDate !==''">{{ "products.tab-portfolio"| translate }}
      <small
          *ngIf="asOfDate || data?.asOfDate">{{ "products.portfolio-current-allocations" | translate }} {{ "products.as-of-capitalize"| translate }} {{ data?.asOfDate ? data?.asOfDate : asOfDate }}</small>
    </h3>
  </div>

  <div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="Equity-tab-pane" role="tabpanel" aria-labelledby="Equity-tab"
         tabindex="0">
      <div class="row portfolio-graphs">
        <!-- Top Holdings start -->
        <div [ngClass]="getClass()" *ngIf="isTopTenPopulated">
          <h4>{{ "products.portfolio-top-holdings"| translate }}&nbsp;
            <span class="port-smalltext">{{ topTenSmallTitle }}</span>
          </h4>
          <div class="progress-box">
            <div class="progress-block"
                 *ngFor="let item of getColumns(topTenHoldings,true)[0] | slice:0:5;">
              <div>{{ item?.label }}</div>
              <div class="d-flex">
                <div class="progress">
                  <div class="progress-bar {{item?.progressBarColor}}" role="progressbar" aria-label="Success example"
                       [style.width]=item?.progressPercent
                       [attr.aria-valuenow]=item?.progressPercent
                       aria-valuemin="0"
                       aria-valuemax="100">
                  </div>
                </div>
                <span>&nbsp;{{ item?.breakdown }}</span>
              </div>
            </div>
            <div class="text-center d-md-none">
              <a href="#" (click)="false">
                <span data-bs-toggle="modal" class="mt-0" style="font-size:0.875rem;"
                      data-bs-target="#holdingsModal">{{ "products.portfolio-view-all-holdings" | translate }}</span>
                <i class="bi bi-chevron-right"></i>
              </a>
            </div>
          </div>
          <div class="text-center d-none d-lg-block">
            <a href="#" (click)="false" style="margin: auto;">
              <span data-bs-toggle="modal" class="link-test"
                    data-bs-target="#holdingsModal">{{ "products.portfolio-view-all-holdings" | translate }}</span>
              <i class="bi bi-chevron-right"></i>
            </a>
          </div>
        </div>
        <!-- Top Holdings Ends -->
        <!-- PortFolio Composition Starts -->
        <div [ngClass]="getClass()" *ngIf="piChartPopulated">
          <h4>{{ "products.portfolio-composition-title" | translate }}</h4>
          <ft-pi-chart [data]="portfolioComposition"></ft-pi-chart>
        </div>
        <!-- PortFolio Composition Ends -->
        <!-- Sector BreakDown Starts -->
        <div [ngClass]="getClass()" *ngIf="data?.allocations">
          <h4>{{ "products.portfolio-top-sectors" | translate }}&nbsp;
            <span class="port-smalltext">{{ data.calculationType }}</span>
          </h4>
          <div class="progress-box">
            <div class="progress-block"
                 *ngFor="let item of getColumns(data?.allocations,false)[0] | slice:0:5;">
              <div>{{ item?.sectorName }}</div>
              <div class="d-flex">
                <div class="progress">
                  <div class="progress-bar {{item?.progressBarColor}}" role="progressbar" aria-label="Success example"
                       [style.width]=item?.progressPercent
                       [attr.aria-valuenow]=item?.progressPercent
                       aria-valuemin="0"
                       aria-valuemax="100">
                  </div>
                </div>
                <span>&nbsp;{{ item?.breakdown }}</span>
              </div>
            </div>
            <div class="text-center d-md-none">
              <a href="#" (click)="false">
                <span data-bs-toggle="modal" class="mt-0" style="font-size:0.875rem;"
                      data-bs-target="#sectorsModal">{{ "products.portfolio-view-all-sectors" | translate }}</span>
                <i class="bi bi-chevron-right"></i>
              </a>
            </div>
          </div>
          <div class="text-center d-none d-lg-block">
            <a href="#" (click)="false" style="margin: auto;">
              <span data-bs-toggle="modal" class="link-test"
                    data-bs-target="#sectorsModal">{{ "products.portfolio-view-all-sectors" | translate }}</span>
              <i class="bi bi-chevron-right"></i>
            </a>
          </div>
        </div><!-- Sector BreakDown Ends -->
      </div>
    </div>
  </div>
  <!-- View Portfolio Button -->
  <div class="block-footer" *ngIf="linkFromLiteratureService.buttonLink">
    <div class="download-plan">
      <a [href]="linkFromLiteratureService.buttonLink" class="me-lg-5 me-3" id="downloadpdf" target="_blank">
        <img alt="view portfolio" src="assets/images/home/pdf.svg">{{ "products.view-portfolio" | translate }}
      </a>
    </div>
  </div>
</div>

<!--- holdings modal -->
<div *ngIf="isTopTenPopulated" class="modal fade small-modal" id="holdingsModal" tabindex="-1"
     aria-labelledby="holdingsModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="holdingsModalLabel">{{ "products.portfolio-all-holdings" | translate }}&nbsp;
          <span class="port-smalltext">{{ topTenSmallTitle }}</span>
        </h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body pe-2">
        <div class="holding-block">
          <div class="progress-block" *ngFor="let item of getColumns(topTenHoldings, true)[0]">
            <div>{{ item?.label }}</div>
            <div class="d-flex">
              <div class="progress">
                <div class="progress-bar {{item?.progressBarColor}}" role="progressbar" aria-label="Success example"
                     [style.width]=item?.progressPercent
                     [attr.aria-valuenow]=item?.progressPercent
                     aria-valuemin="0"
                     aria-valuemax="100">
                </div>
              </div>
              <span>&nbsp;{{ item?.breakdown }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--- Sectors modal -->
<div *ngIf="data?.allocations" class="modal fade small-modal" id="sectorsModal" tabindex="-1"
     aria-labelledby="sectorsModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="sectorsModalLabel">{{ "products.portfolio-top-sectors" | translate }}&nbsp;
          <span class="port-smalltext">{{ data.calculationType }}</span>
        </h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body pe-2">
        <div class="holding-block">
          <div class="progress-block" *ngFor="let item of getColumns(data?.allocations,false)[0]">
            <div>{{ item?.sectorName }}</div>
            <div class="d-flex">
              <div class="progress">
                <div class="progress-bar {{item?.progressBarColor}}" role="progressbar" aria-label="Success example"
                     [style.width]=item?.progressPercent
                     [attr.aria-valuenow]=item?.progressPercent
                     aria-valuemin="0"
                     aria-valuemax="100">
                </div>
              </div>
              <span>&nbsp;{{ item?.breakdown }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
